module.exports = __webpack_public_path__ + "static/media/5.7.d5f62a6e.png";